import { inject, Injectable } from '@angular/core';
import { DemoType } from '@app/+onboarding/components/demo-dialog/demo-dialog.model';
import { DemoDialogService } from '@app/+onboarding/components/demo-dialog/demo-dialog.service';
import { SbDialogService } from '@sb/ui/dialog';
import { of, switchMap, take, tap } from 'rxjs';

import { OnboardingDialogResult } from '../../../+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { UserGuideType } from '../../../reducers/orm/user-guide/user-guide.model';
import { SmbHospitalityOnboardingChecklistStep } from '../../../shared/onboarding/onboarding-checklist.model';
import { OnboardingChecklistService } from '../../../shared/onboarding/onboarding-checklist.service';
import { OnboardingUtils } from '../../onboarding.utils';
import { TimeTrackingDialogComponent } from '../time-tracking/time-tracking-dialog.component';
import { TimeTrackingSummaryDialogComponent } from '../time-tracking/time-tracking-summary-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class TimeTrackingOnboardingService {
  private onboardingChecklist = inject(OnboardingChecklistService);
  private onboardingUtils = inject(OnboardingUtils);
  private dialogService = inject(SbDialogService);
  private demoDialogService = inject(DemoDialogService);

  openDialog(originator = 'onboarding') {
    return this.dialogService
      .setSize('xxl')
      .open(TimeTrackingDialogComponent, { data: { originator } })
      .closed.pipe(
        take(1),
        tap((result: OnboardingDialogResult) => {
          if (!result?.action) {
            this.onboardingUtils.stripOnboardingParamsFromRoute();
          }
        }),
      );
  }

  openDemo(skipFlow?: boolean) {
    return this.demoDialogService.openDemo(DemoType.TIME_TRACKING).pipe(
      switchMap(() => {
        if (!skipFlow) {
          return this.onboardingChecklist.completeStep(
            UserGuideType.SELF_ONBOARDING_CHECKLIST,
            SmbHospitalityOnboardingChecklistStep.TIME_TRACKING,
          );
        }
        return of(false);
      }),
    );
  }

  openSummary(originator: string) {
    return this.dialogService
      .setSize('xxl')
      .open(TimeTrackingSummaryDialogComponent, { data: { originator } })
      .closed.pipe(take(1));
  }
}
